<template>
    <section class="map">
        <div class="map__inner">
            <gmap-map class="map__item" :center="center.display" :zoom="zoom.display" :options="options">
                <gmap-marker :key="index" v-for="(location, index) in locations.display" :position="location.position" :icon="getIcon(location.type)" @click="redirect(location)"></gmap-marker>

                <gmap-marker :key="'postcode'" :position="postcode.position" :icon="postcode.icon" @click="center=postcode.position" v-if="Object.keys(postcode.position).length > 0"></gmap-marker>
            </gmap-map>

            <div class="map__loading" v-if="loading">
                Loading..
            </div>
        </div>

        <div class="map__overlay" :class="{'active': overlay}">
            <a href="#" class="map__overlay__menu shadow-lg" v-tooltip.right="'Show list view'" @click="toggle()" v-if="!overlay">
                <i class="fa  fa-bars"></i>
            </a>

            <a href="#" class="map__overlay__menu shadow-lg" v-tooltip.right="'Hide list view'" @click="toggle()" v-if="overlay">
                <i class="fa  fa-bars"></i>
            </a>

            <div class="map__overlay__inner">
                <div class="map__overlay__item" v-for="(location, index) in locations.display">
                    <h4 class="map__overlay__item__ttl">{{ location.name }}</h4>

                    <p class="map__overlay__item__address">
                        {{ location.address.line_1 }},<br/>
                        <span v-if="typeof location.address.line_2 != 'undefined'">
                            {{ location.address.line_2 }},<br />
                        </span>
                        {{ location.address.city }}, <br/>
                        {{ location.address.postcode }}
                    </p>

                    <p v-if="typeof location.distance != 'undefined'">
                        <small>{{ location.distance }} mile(s) away from your location.</small>
                    </p>

                    <div class="px-2 block w-full">
                        <a href="#" class="btn btn--pill btn--full btn--primary btn--blue btn--text--white  btn--sml  mb-2">CALL {{ location.telephone }}</a>
                    </div>
                    <div class="px-2 block w-full">
                        <a href="#" class="btn btn--pill btn--full btn--primary btn--transparent btn--bordered btn--bordered--blue btn--text--blue btn--hover btn--hover--blue btn--hover--text--white  btn--sml" @click="redirect(location)">See more</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="map__footer">
            <div class="map__footer__wiggle">
                <slot name="wiggle"></slot>
            </div>

            <form class="map__footer__form" @submit.prevent="handle">
                <h4 class="map__footer__ttl">Find your nearest moon</h4>

                <div class="map__footer__form__inner">
                    <div class="map__footer__form__field">
                        <input type="text" name="postcode" class="form__input  map__footer__form__input" placeholder="Enter a postcode or town" autocomplete="off" v-model="postcode.text" v-if="!loading" />

                        <input type="text" name="postcode" class="form__input  map__footer__form__input" placeholder="Enter a postcode or town" autocomplete="off" disabled v-model="postcode.text" v-if="loading" />

                        <a href="#" class="map__footer__form__reset" v-if="Object.keys(postcode.position).length > 0" @click="reset()" v-tooltip.left="'Reset Location'">
                            <i class="fa  fa-times"></i>
                        </a>
                    </div>

                    <button class="map__footer__form__btn" v-if="!loading" :disabled="loading">
                        Search
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import json from '../json/map.json'

export default {
    name: 'GoogleMapComponent',
    data: () => ({
        center: {
            display: {
                lat: 52.737227,
                lng: -1.204770
            },
            default: {
                lat: 52.737227,
                lng: -1.204770
            }
        },
        zoom: {
            display: 7,
            default: 7
        },
        markers: {
            icon: {
                url: '/img/marker.png'
            },
            icon_club: {
                url: '/img/marker_club.png'
            }
        },
        locations: {
            display: [],
            default: []
        },
        options: {
            styles: json,
            disableDefaultUI: true
        },
        postcode: {
            text: '',
            icon: {
                url: '/img/marker--secondary.png'
            },
            position: {}
        },
        loading: true,
        modal: {
            open: false,
            index: null
        },
        overlay: false
    }),

    mounted() {
        this.create();
    },

    methods: {
        getIcon(type) {
            if (type == 'nursery') {
                return this.markers.icon;
            } else {
                return this.markers.icon_club;
            }
        },

        create() {
            BananaMoon.request().post('/locations', {
                    postcode: this.postcode
                })
                .catch(error => {
                    this.loading = false;
                })
                .then(response => {
                    if(typeof response.data.locations != 'undefined') {
                        this.locations.display = response.data.locations;
                        this.locations.default = response.data.locations;
                    }

                    this.$nextTick(() => {
                        this.loading = false;
                    });
                });
        },
        handle() {
            this.loading = true;

            BananaMoon.request().post('/postcode', {
                    postcode: this.postcode.text
                })
                .catch(error => {
                    this.loading = false;
                })
                .then(response => {
                    if(typeof response.data.coordinates != 'undefined') {
                        this.postcode.position = response.data.coordinates;
                        this.zoom.display = 10;
                        this.center.display = response.data.coordinates;
                    }

                    if(typeof response.data.locations != 'undefined') {
                        this.locations.display = response.data.locations;
                        this.overlay = true;
                    }

                    this.$nextTick(() => {
                        this.loading = false;
                    });
                });
        },
        open(index) {
            this.modal.index = index;
            this.modal.open = true;
        },
        redirect(location) {
            const slug = location.slug;
            if (slug == 'mirfield') {
                window.location.href = location.website;
            } else {
                window.location.href = `/find-us/${slug}`;
            }
        },
        reset() {
            this.loading = true;

            this.center.display = this.center.default;
            this.zoom.display = this.zoom.default;

            this.postcode.position = {};
            this.postcode.text = '';

            this.locations.display = this.locations.default;

            this.$nextTick(() => {
                this.loading = false;
            });
        },
        toggle() {
            this.overlay = !this.overlay;
        }
    },
}
</script>

<style>
    .map {
        position: fixed!important;
        top: 96px;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
    }

    /**
     * Inner
     */
    .map__inner {
        position: static;
    }

    /**
     * Loading
     */
    .map__loading {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 20;

        background: rgba(0, 0, 0, 0.75);
    }

    /**
     * Item
     */
    .map__item {
        position: absolute!important;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    /**
     * Overlay
     */
    .map__overlay {
        position: absolute;
        top: 0;
        left: -300px;
        bottom: 0;
        z-index: 15;

        width: 300px;

        background: #F5F5F5;

        transition: left 0.2s ease-in-out;
    }
    .map__overlay.active {
        left: 0px;
    }

    /**
     * Overlay > Inner
     */
    .map__overlay__inner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;

        padding: 20px 20px 250px 20px;
    }

    @media screen and (max-width: 1300px) {
        .map__overlay__inner {
            padding: 20px 20px 150px 20px;
        }
    }

    /**
     * Overlay > Menu
     */
    .map__overlay__menu {
        position: absolute;
        top: 50%;
        right: -62px;

        width: 62px;
        padding: 20px;

        font-size: 24px;
        color: #FFFFFF;

        background: #0F86C3;

        transform: translateY(-50%);
    }

    .map__overlay__menu svg {
        display: block;
    }

    /**
     * Overlay > Item
     */
    .map__overlay__item {
        display: block;
        padding-bottom: 20px;
        margin-bottom: 20px;

        text-align: center;

        border-bottom: 1px solid #E0E0E0;
    }
    .map__overlay .map__overlay__item:last-child {
        margin-bottom: 0px;

        border-bottom: none;
    }

    /**
     * Footer
     */
    .map__footer {
        position: absolute;
        bottom: -30px;
        left: 0;
        right: 0;
        z-index: 25;
    }

    @media screen and (max-width: 1300px) {
        .map__footer {
            bottom: 0px;

            padding: 20px;

            background: #0091DA;
        }
    }

    /**
     * Footer > Wiggle
     */
    .map__footer__wiggle {
        display: block;
        width: 100%;
    }
    .map__footer__wiggle svg {
        display: block;
    }
    .map__footer__wiggle svg path {
        fill: #0091DA;
    }

    @media screen and (max-width: 1300px) {
        .map__footer__wiggle {
            display: none;
        }
    }

    /**
     * Footer > Title
     */
    .map__footer__ttl {
        margin-bottom: 10px;

        font-size: 20px;
        line-height: 20px;
        color: #FFFFFF;
    }

    /**
     * Footer > Form
     */
    .map__footer__form {
        position: absolute;
        right: 0;
        bottom: 50px;
        z-index: 15;

        width: 100%;
        max-width: 300px;
    }

    @media screen and (max-width: 1300px) {
        .map__footer__form {
            position: relative;
            right: auto;
            bottom: auto;

            margin: 0 auto;
        }
    }

    /**
     * Footer > Form > Inner
     */
    .map__footer__form__inner {
        position: relative;

        padding-right: 20px;
    }

    @media screen and (max-width: 1300px) {
        .map__footer__form__inner {
            padding-right: 0px;
        }
    }

    /**
     * Footer > Form > Field
     */
    .map__footer__form__field {
        position: relative;
    }

    /**
     * Footer > Form > Button
     */
    .map__footer__form__btn {
        display: block;
        width: 100%;
        padding: 5px;
        margin-top: 10px;

        background: #FFFFFF;

        color: #0091DA;
        font-weight: 200;
        font-size: 14px;
        text-transform: uppercase;

        border: 2px solid #FFFFFF;

        transition: all 0.2s ease-in-out;
    }
    .map__footer__form__btn:hover {
        padding-right: 10px;

        background: #0091DA;

        color: #FFFFFF;
    }
    .map__footer__form__btn svg {
        display: block;
    }
    .map__footer__form__btn i:before {
        display: block;
    }

    /**
     * Footer > Form > Input
     */
    .map__footer__form__input {
        width: 100%;
        height: auto;
        padding: 10px 35px 10px 10px;

        border: 1px solid rgba(225, 225, 225, 0.5);

        transition: border 0.2s ease-in-out;
    }
    .map__footer__form__input:focus {
        border: 1px solid rgba(225, 225, 225, 0.75);
    }

    /**
     * Footer > Forn > Reset
     */
    .map__footer__form__reset {
        position: absolute;
        top: 50%;
        right: 10px;

        font-size: 24px;
        color: #FFFFFF;

        transform: translateY(-50%);
    }

    @media screen and (max-width: 991px) {
        .map__details {
            margin-top: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// GoogleMap.vue?057ea2a4